<template>
  <div v-if="orgData" class="the-navbar__user-meta flex items-center">

    <div v-if="orgData.name" class="text-right leading-tight hidden sm:block items-center mr-3">
      <h6>{{ orgData.name }}</h6>
      <!-- <small>Online</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img">
        <!-- <img v-if="userData.profilePictureUrl" key="onlineImg" :src="constants.s3Bucket+'/editor/profile-pictures/'+userData.profilePictureUrl" alt="user-img" width="32" height="32" class="rounded-full shadow-md cursor-pointer block" />
        <img v-else key="onlineImg" src="@/assets/images/icons/gender/default.png" alt="user-img" width="32" height="32" class="rounded-full shadow-md cursor-pointer block" /> -->
        <vs-avatar
          v-if="orgData.logo"
          class="m-0"
          size="32px"
          :src="constants.s3Bucket + '/organization/logo/' + orgData.logo"
        />
        <vs-avatar
          v-else
          class="m-0"
          size="32px"
          :src="
            require('@/assets/images/icons/organization/business_black_36dp.svg')
          "
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 15rem">

          <!-- Language Switcher -->
          <li class="py-2 px-4">
            <div class="flex items-center">
              <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4 mr-4" />
              <div class="flex border rounded overflow-hidden">
                <div 
                  class="px-3 py-1 text-xs font-medium cursor-pointer transition-colors flex items-center"
                  :class="$i18n.locale === 'en' ? 'bg-primary text-white' : 'bg-gray-100 hover:bg-gray-200'"
                  @click="updateLocale('en')">
                  <img class="h-3 w-4 mr-1" src="@/assets/images/flags/en.png" alt="en" />
                  EN
                </div>
                <div 
                  class="px-3 py-1 text-xs font-medium cursor-pointer transition-colors flex items-center"
                  :class="$i18n.locale === 'pt' ? 'bg-primary text-white' : 'bg-gray-100 hover:bg-gray-200'"
                  @click="updateLocale('pt')">
                  <img class="h-3 w-4 mr-1" src="@/assets/images/flags/pt.png" alt="pt" />
                  PT
                </div>
              </div>
            </div>
          </li>

          <vs-divider class="m-1" />

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push({ name: 'org-board-templates' }).catch(() => {})">
              <vs-icon icon="dashboard" size="17px" />
              <span class="ml-2">Create Board</span>
          </li> -->

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push({ name: 'org-settings' }).catch(() => {})">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/user/messages').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Messages</span>
          </li> -->

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/organization/marketplace').catch(() => {})">
            <feather-icon icon="ShoppingIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Marketplace</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import constants from "@/constants";
export default {
  data() {
    return {
      constants
    }
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    currentLanguage() {
      return this.$i18n.locale === 'en' ? 'EN' : 'PT';
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
    },
    logout() {
      //TalentPaint Session Destroy For Alex
      this.$store.dispatch("alex/deleteSession", this.$store.state.auth.user._id);
      //TalentPaint Session Destroy For Gala Or Journey App
      this.$store.dispatch("boards/deleteSession", this.$store.state.auth.user._id);
      //Youlab Session Destroy For Gala Or Journey App
      this.$store.dispatch("editor/deleteSession", this.$store.state.auth.user._id);
      this.$store.dispatch("auth/logout").then(() => {
        window.location.href = "/";
      });
    },
  }
};
</script>
